export default {
    searchByVisitorName: 'ค้นหาจากชื่อผู้เยี่ยมเยือน',
    search: 'ค้นหา',
    createNewVisitor: 'สร้างผู้เยี่ยมเยือน',
    visitorName: 'ชื่อผู้เยี่ยมเยือน',
    contact: 'ติดต่อ',
    contactNo: 'เบอร์โทรศัพท์',
    dateCreate: 'วันที่สร้าง',
    upcomingAccess: 'การเข้าเยี่ยมที่กำลังจะมาถึง',
    status: 'สถานะ',
    action: 'ปุ่มคำสั่ง',
    delete: 'ลบผู้เยี่ยมเยือน',
    deleted: 'คุณแน่ใจหรือว่าต้องการลบ',
    deleteSuccess: 'ลบผู้เยี่ยมเยือนแล้ว'
}
